import React from "react";
import Slider from "react-rangeslider";
import { Col } from "Components";
import calulatorImg from "./../../media/calculator.png";
import get_criteria from "actions/get_criteria";
import get_credits from "actions/get_credits";
import get_credit_type from "actions/get_credit_type";
import calculate_loan from "actions/calculate_loan";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
class Calculation extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      pv: 25,
      np: 8,
      selectedCurrency: null,
      showPaymentPlan: false
    };
  }
  async componentDidMount() {
    await this.props.get_criteria();
    await this.props.get_credits();
    await this.props.get_credit_type();
  }

  render = () => (
    <div>
      <div
        className={`modal_container ${
          this.state.showPaymentPlan ? "" : "hide"
        }`}
      >
        <div className="modal">
          <div className="header_nav">
            <p>Ödeme Planı</p>
            <button
              onClick={() => {
                this.setState({
                  showPaymentPlan: false
                });
              }}
              className="close"
            >
              X
            </button>
          </div>
          <div className="content">
            {this.props.loan_calculation ? (
              <table className="payments">
                <tr>
                  <th>Taksit No</th>
                  <th>Anapara</th>
                  <th>Taksit</th>
                  <th>Faiz</th>
                  <th>Bsiv</th>
                  <th>Düşülen</th>
                  <th>Kalan</th>
                </tr>
                {this.props.loan_calculation
                  ? this.props.loan_calculation.payments.map(i => (
                      <tr>
                        <td>{i.monthIndex}</td>
                        <td>{i.principal}</td>
                        <td>{i.tax}</td>
                        <td>{i.interest}</td>
                        <td>{i.bsiv}</td>
                        <td>{i.deducting}</td>
                        <td>{i.remaining}</td>
                      </tr>
                    ))
                  : null}
              </table>
            ) : null}
          </div>
        </div>
      </div>
      <div className="calculation-wrapper">
        <div className="container row">
          <img alt="" className="character" src={calulatorImg} />
          <div className="calculator_form">
            <div className="form_row">
              <div className="wrap-half">
                <p>Kredi Türü</p>
                <select
                  value={this.state.credit_type_id}
                  onChange={e => {
                    this.setState({
                      credit_type_id: e.target.value
                    });
                  }}
                >
                  <option value={null}>--Kredi Türü Seçin---</option>
                  {this.props.credit_type.map(i => (
                    <option key={i.id} value={i.id}>
                      {i.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="wrap-half">
                <p>Kredi</p>
                <select
                  value={this.state.credit_id}
                  onChange={e => {
                    this.setState({
                      credit_id: e.target.value
                    });
                  }}
                >
                  <option value={null}>--Kredi Seçin---</option>
                  {this.props.credits.map(i => (
                    <option key={i.id} value={i.id}>
                      {i.title}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="form_row">
              <div className="money_selection_radio">
                <p>Para Birimi </p>
                {this.props.criteria.map((i, index) => (
                  <label key={index} className="custom-input">
                    <input
                      type="radio"
                      onChange={e => {
                        this.setState({
                          selectedCurrency: i
                        });
                      }}
                      name="radioFoo"
                      value={i.id}
                    />
                    <span className="check-radio" />
                    <span className="custom-input-label">
                      {i.currency_title}
                    </span>
                  </label>
                ))}
              </div>
            </div>
            <div className="form_row mt20">
              <div className="wrap-half">
                <p>Vade</p>
                <div className="slider orientation-reversed">
                  <div className="slider-group">
                    <div className="slider-horizontal">
                      <Slider
                        min={
                          this.state.selectedCurrency
                            ? this.state.selectedCurrency.min_np
                            : 0
                        }
                        max={
                          this.state.selectedCurrency
                            ? this.state.selectedCurrency.max_np
                            : 12
                        }
                        value={this.state.np}
                        orientation="horizontal"
                        onChange={np => {
                          this.setState({
                            np
                          });
                        }}
                      />
                    </div>
                    <div className="slider_value">{this.state.np} Ay</div>
                  </div>
                </div>
              </div>
              <div className="wrap-half">
                <p>Kredi Tutarı</p>
                <div className="slider orientation-reversed">
                  <div className="slider-group">
                    <div className="slider-horizontal">
                      <Slider
                        min={
                          this.state.selectedCurrency
                            ? this.state.selectedCurrency.min_pv
                            : 0
                        }
                        max={
                          this.state.selectedCurrency
                            ? this.state.selectedCurrency.max_pv
                            : 50000
                        }
                        value={this.state.pv}
                        orientation="horizontal"
                        onChange={pv => {
                          this.setState({
                            pv
                          });
                        }}
                        step={500}
                      />
                    </div>
                    <div className="slider_value">{this.state.pv} TL</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="calculator_wrapper minus-65-top">
        <div className="container row">
          <button
            onClick={() => {
              this.props.calculate_loan({
                np: this.state.np,
                pv: this.state.pv,
                ir: this.state.selectedCurrency.ir,
                tr: this.state.selectedCurrency.tr
              });
            }}
            disabled={!this.state.selectedCurrency}
          >
            HESAPLA
          </button>
        </div>
      </div>
      {this.props.loan_calculation ? (
        <div className="payment_plan bg-light-orange">
          <div className="container row">
            <Col className="item" l={4} m={12}>
              <ul>
                <li>
                  <p>Aylık Faiz Oranı</p>
                  <span>% 1,4</span>
                </li>
                <li>
                  <p>Kredi Tutarı</p>
                  <span>20.000 TL</span>
                </li>
                <li>
                  <p>Aylık Taksit Tutarı</p>
                  <span>610,31 TL</span>
                </li>
              </ul>
            </Col>
            <Col className="item" l={4} m={12}>
              <ul>
                <li>
                  <p>Toplam Geri Ödeme Tutarı</p>
                  <span>29.295,11 TL</span>
                </li>
                <li>
                  <p>Kredi Tahsis Ücreti</p>
                  <span>105 TL</span>
                </li>
                <li>
                  <p>Ferdi Kaza Sigortası</p>
                  <span>99 TL</span>
                </li>
              </ul>
            </Col>
            <Col className="item" l={4} m={12}>
              <ul>
                <li>
                  <p>Toplam Masraf</p>
                  <span>204 TL</span>
                </li>
                <li>
                  <p>Aylık Efektif Faiz Oranı</p>
                  <span>% 1,7051</span>
                </li>
                <li>
                  <p>Yıllık Efektif Faiz Oranı</p>
                  <span>% 22,4933</span>
                </li>
              </ul>
            </Col>
          </div>
          <div className="container row">
            <Col className="item" l={9} m={12}>
              <p className="description">
                Yıllık Efektif Faiz Oranına Kasko Poliçe bedeli dahil
                edilmemiştir. Kasko bedeli aracın yaşına, modeline göre
                değişkenlik göstermektedir, NovaBank Şubeleri’nden detaylı bilgi
                alınmasını rica ederiz. Hesaplamada yer alan Ferdi Kaza Sigorta
                bedeli ortalama bir değerdir, kredi kullanacak kişinin yaşına ve
                kullanılacak kredi tutarına göre değişmektedir.
                <span>Detaylı bilgiye buradan ulaşabilirsiniz.</span>
              </p>
            </Col>
            <Col className="item" l={3} m={12}>
              <button
                onClick={() => {
                  this.setState({
                    showPaymentPlan: true
                  });
                }}
                className="payment_plan_button"
              >
                Ödeme Planı
              </button>
            </Col>
          </div>
        </div>
      ) : null}
    </div>
  );
}
const mapStateToProps = state => ({
  criteria: state.criteria ? state.criteria.data : [],
  credits: state.credits,
  credit_type: state.credit_type,
  loan_calculation: state.loan_calculation ? state.loan_calculation.data : false
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_criteria,
      calculate_loan,
      get_credits,
      get_credit_type
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calculation);
